import React from 'react';
import { useAuth } from '../contexts/AuthContext';

const Profile = () => {
    const { user } = useAuth();
    return (
        <div className="container mx-auto px-4 py-8">
            <h1 className="text-3xl font-bold mb-4">个人中心</h1>
            {user ? (
                <div className="bg-white shadow rounded-lg p-6">
                    <p className="text-lg mb-2">欢迎, {user.username || user.email}</p>
                    <p className="text-gray-600">邮箱: {user.email}</p>
                </div>
            ) : (
                <p className="text-gray-600">请先登录</p>
            )}
        </div>
    );
};
export default Profile;
